// extracted by mini-css-extract-plugin
export default {"layout":"layOut_layout__sIs+8"};